import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import click_outside_Vv8thPUWp8 from "/app/src/plugins/click-outside.ts";
import imgproxy_blinkloader_client_vNRdUjRJfD from "/app/src/plugins/imgproxy-blinkloader.client.ts";
import v_mask_hf6fHkTZn6 from "/app/src/plugins/v-mask.js";
import vue_toastification_SxPdrNCQ4A from "/app/src/plugins/vue-toastification.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  click_outside_Vv8thPUWp8,
  imgproxy_blinkloader_client_vNRdUjRJfD,
  v_mask_hf6fHkTZn6,
  vue_toastification_SxPdrNCQ4A
]